import axios from "axios";

const submitNotification = async (
    userId: number | string,
    notificationType: string,
    message: string
) => {
    console.log("Submitting notification:", userId, notificationType, message);
    try {
        const response = await axios.post(`${import.meta.env.VITE_API_URL}/notifications/notifications`, {
            user_id: userId,
            notification_type: notificationType,
            status: "unread",
            message: message,
        });
        console.log("Notification submitted:", response.data);
    } catch (error) {
        console.error("Error submitting notification:", error);
    }
};

export default submitNotification; 